/** Format billing units without hiding supported hundredth-unit values. */
export function formatUnits(units: number): string {
	const hundredths = units.toFixed(2);
	return hundredths.endsWith("0") ? hundredths.slice(0, -1) : hundredths;
}
